/** Actualización Docente — sin comprobante PDF */
export const TIPO_ACTUALIZACION_DOCENTE = 2;

export function isActualizacionDocente(tipoPeriodo: number | string | undefined) {
  return Number(tipoPeriodo) === TIPO_ACTUALIZACION_DOCENTE;
}
